export const PositionTypeEnum = Object.freeze({
  current: "1",
  realtime: "2",
  unknown: "3",
  basic: "4",
});
